var Global = {

    url_api: 'https://api.cafiramarket.com/api/',

}


export default Global;